import { createSlice } from "@reduxjs/toolkit";

interface DecodedToken {
  Role: string;
  exp?: number;
}

const decodeJWT = (token: string): DecodedToken | null => {
  try {
    const base64Url = token.split('.')[1]; // Get payload (second part)
    if (!base64Url) throw new Error('Invalid token format');

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convert Base64Url7 to Base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload) as DecodedToken;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export const authSlice = createSlice({
  name: "auth",
  initialState: { user: null, refreshToken: null, accessToken: null, expires: null },
  reducers: {
    setCredentials: (state, action) => {
      //   state.isOpen = !state.isOpen;
      const { user, refreshToken, accessToken, expires } = action.payload
      state.user = user
      state.refreshToken = refreshToken
      state.accessToken = accessToken
      state.expires = expires
      // console.log("auth state set")
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('user', user);
      localStorage.setItem('expires', expires);

      if (accessToken) {
        try {
            // Decode the JWT
            const decoded = decodeJWT(accessToken);
            if (decoded) {
                localStorage.setItem('role', decoded.Role);
            }
        } catch (error) {
            console.error('Invalid JWT:', error);
        }
    }

    },
    logOut: (state) => {
      state.user = null
      state.refreshToken = null
      state.accessToken = null
      state.expires = null
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state: any) => state.auth.user
export const selectAccessToken = (state: any) => state.auth.accessToken
export const selectRefreshToken = (state: any) => state.auth.refreshToken
export const selectExpires = (state: any) => state.auth.expires